import { reqLoginByKeXieToken } from '@/api/user';
import { useUserStore } from '@/stores';
import ccworkBridge from 'ccwork-jsbridge';
import { showToast } from 'vant';

const ccwork = ccworkBridge.default || ccworkBridge;

/**
 * 是否在智慧科协app环境中
 *
 * @export
 * @return {boolean}
 */
export function isKeXieApp() {
  return ccwork.isCCWorkPC() || ccwork.isCCWork();
}

/**
 * 调用智慧科协app功能底层方法
 *
 * @export
 * @param {string} funcName 客户端提供的方法名称
 * @param {T} data 客户端提供的方法所需要的参数
 * @return {*}
 */
export function callKeXieAppFunc<T extends object>(funcName: string, data?: T) {
  return new Promise((resolve, reject) => {
    const params = {
      type: funcName, // native的接口名
      data, // 方法参数
    };
    ccwork.ccworkCallNative?.(
      params,
      (res: { status: number; [key: string]: unknown }) => {
        if (res.status === 1) {
          resolve(res);
        } else {
          reject(res);
        }
      }
    );
  });
}

/**
 * 唤起智慧科协APP登录界面
 *
 * @export
 * @param {boolean} [isReload=true] 是否重新加载页面
 * @return {*}
 */
export function launchKeXieAppLogin(isReload = true) {
  return callKeXieAppFunc('ccworkGoLogin', {
    text: 'login',
  })
    .then((res) => {
      if (isReload) {
        window.location.reload();
      }
      return (<{ result: { token: string } }>res).result.token;
    })
    .catch((error) => {
      console.error('调起App登录失败');
      return error;
    });
}

/**
 * 获取智慧科协app的token
 *
 * @export
 * @param {boolean} [newToken=false] 是否获取新token
 * @return {*}
 */
export function getKeXieAppToken(newToken = false) {
  return new Promise((resolve: (value: string) => void, reject) => {
    console.log('get app token');
    ccwork.ccwork3rdPartToken(
      newToken,
      (res: { status: number; [key: string]: unknown }) => {
        console.log('ccwork3rdPartToken获取到token', res);
        if (res.status == 1) {
          resolve((res.result as { token: string })?.token ?? '');
        } else {
          reject(res);
        }
      }
    );
  });
}

/**
 * 通过智慧科协App登录系统
 * @param {boolean} [force=true] 是否强制登录，默认强制登录
 * @throws {Error} 如果获取token失败或登录请求失败，会抛出错误
 */
export async function loginByKeXieApp(force = true) {
  try {
    let token = await getKeXieAppToken();
    if (token) {
      showToast({
        message: '自动登录中',
      });
    } else {
      if (!force) {
        setTimeout(() => {
          loginByKeXieApp(false);
        }, 2000);
        return;
      }
      token = await launchKeXieAppLogin(false);
    }
    const res = await reqLoginByKeXieToken({ zhkx_token: token });
    console.log('🚀 ~ loginByKeXieApp ~ res:', res);
    const userStore = useUserStore();
    userStore.setLoginUser(res.data);
    showToast({
      message: '登录成功',
    });
  } catch (error) {
    console.log(error);
  }
}
